export default __webpack_public_path__ + "static/media/vision.43264b1d.png";